<template>
  <div class="mb-5 text-h6 heading">
    {{ engineerAccess.parkingDetails.question }}
  </div>
  <SoTextarea
    v-model="engineerAccess.parkingDetails.answer"
    :max-length="maxLength"
    counter
    :rules="[rules.required]"
  />
  <SoCheckbox
    v-model="hasPets"
    label="There are pets at the property that may interfere with the appointment"
    class="mt-3 mb-n2"
  />
  <div v-if="hasPets" class="mt-7 mb-n6">
    <p>{{ engineerAccess.petDetails.question }}</p>
    <SoTextarea
      v-model="engineerAccess.petDetails.answer"
      class="mt-5"
      :max-length="maxLength"
      counter
      :rules="[rules.required]"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoTextarea from "@/components/formControls/SoTextarea.vue"
  import { IMBP_TEXT_AREA_MAX_LENGTH } from "@/constants/imbp"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"
  import rules from "@/validators/rules"
  import { ImbpQuestionnaire } from "@/flows/useCases/imbpBookingNew/types"

  export default defineComponent({
    components: {
      SoTextarea,
      SoCheckbox,
    },
    props: {
      modelValue: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        maxLength: IMBP_TEXT_AREA_MAX_LENGTH,
        hasPets: false,
        engineerAccess: {
          parkingDetails: {
            question: "Where can the engineer park on the day?",
            answer: "",
          },
          petDetails: {
            question: "Give details of pets",
            answer: "",
          },
        } satisfies ImbpQuestionnaire,
        rules: rules,
      }
    },
    watch: {
      engineerAccess: {
        handler(newValue) {
          this.$emit("update:modelValue", newValue)
        },
        deep: true,
      },
    },
  })
</script>

<style scoped>
  .heading {
    font-weight: 500 !important;
  }
</style>
